import type { ComponentType, ReactNode } from 'react'
import React from 'react'
import { BigLoadingPlaceholder } from './BigLoadingPlaceholder'
import { SmallLoadingPlaceholder } from './SmallLoadingPlaceholder'
import { MediumLoadingPlaceholder } from './MediumLoadingPlaceholder'

export type LoadingPlaceholderProps = {
  children: ReactNode
  loading: boolean
  as?: ComponentType
  size?: 'small' | 'big' | 'medium'
}
export const LoadingPlaceholder = ({ children, loading, as, size }: LoadingPlaceholderProps) => {
  const Component =
    as ??
    (size === 'small' ? SmallLoadingPlaceholder : size === 'medium' ? MediumLoadingPlaceholder : BigLoadingPlaceholder)
  return loading === true ? <Component /> : children
}
